import { AsyncPipe, CommonModule } from '@angular/common';
import { Component, OnInit, inject, viewChild } from '@angular/core';
import { MatAccordion, MatExpansionModule } from '@angular/material/expansion';

import { MatFormFieldModule } from '@angular/material/form-field';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatInputModule } from '@angular/material/input';
import { OidcSecurityTokenService } from '@core/services/oidc-security-token.service';
import { ReactiveFormsModule } from '@angular/forms';

@Component({
    selector: 'rh-inspec-tokens',
    imports: [
        AsyncPipe,
        CommonModule,
        MatExpansionModule,
        MatFormFieldModule,
        MatInputModule,
        MatGridListModule,
        ReactiveFormsModule,
    ],
    templateUrl: './inspect-tokens.component.html',
    styleUrl: './inspect-tokens.component.scss'
})
export class InspectTokensComponent implements OnInit {
  public accordion = viewChild.required(MatAccordion);
  private readonly oidcSecurityTokenService = inject(OidcSecurityTokenService);
  public openPanels: number[] = [];

  get signingKeys$() {
    return this.oidcSecurityTokenService.signingKeys();
  }

  get idToken$() {
    return this.oidcSecurityTokenService.idToken$();
  }

  get idTokenJson$() {
    return this.oidcSecurityTokenService.idTokenJson$();
  }

  get accessToken$() {
    return this.oidcSecurityTokenService.accessToken$();
  }

  get accessTokenJson$() {
    return this.oidcSecurityTokenService.accessTokenJson$();
  }

  ngOnInit(): void {
    this.oidcSecurityTokenService.fetchAuthKeys();
  }

  public onPanelOpen(index: number) {
    if (!this.openPanels.includes(index)) {
      this.openPanels.push(index);
    }
  }

  public onPanelClose(index: number) {
    this.openPanels = this.openPanels.filter((i) => i !== index);
  }

  public isExpanded(index: number): boolean {
    return this.openPanels.includes(index);
  }
}
